<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>{{icon}}</v-icon>
      <h2 class="title ml-2">{{title}}</h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="data">
        <v-text-field
          v-model="value.fecha"
          label="Fecha"
          type="date"
          :error-messages="errFecha"
        ></v-text-field>
        <v-textarea
          v-model="value.pensamiento"
          label="Pensamiento"
          :error-messages="errPensamiento"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import dayjs from 'dayjs'
export default {
  name: 'edit-pensamiento',
  props: ['title', 'icon', 'value'],
  computed: {
    errFecha () {
      const errs = []
      if (!this.$v.value.fecha.$dirty) return errs
      !this.$v.value.fecha.required && errs.push('La fecha es requerida')
      return errs
    },
    errPensamiento () {
      const errs = []
      if (!this.$v.value.pensamiento.$dirty) return errs
      !this.$v.value.pensamiento.required && errs.push('El pensamiento es requerido')
      return errs
    }
  },
  methods: {
    save () {
      this.$v.value.$touch()
      if (!this.$v.value.$invalid) {
        this.$emit('save')
      }
    },
    reset () {
      this.$refs['data'].reset()
      this.$v.$reset()
    }
  },
  mounted () {
    if (!this.value.fecha) {
      this.value.fecha = dayjs().format('YYYY-MM-DD')
    }
  },
  validations: {
    value: {
      fecha: { required },
      pensamiento: { required }
    }
  }
}
</script>
